import { PORTAL_NAME_MODAL_DEFINE } from 'components/common/PortalModal/config';
import { FUNC_DEFAULT } from 'constants';
import usePortalModal from 'hooks/usePortalModal';
import { stringUtils } from 'utils';

const useProfileKYC = () => {
  const { showPortalModalName, closePortalModalName } = usePortalModal();

  const handleShowProfileKYCModal = () => {
    showPortalModalName({
      name: PORTAL_NAME_MODAL_DEFINE.FORM_PROFILE_KYC_MODAL,
    });
  };

  const handleShowProfileKYCSuccessModal = (options) => {
    const { actionClose = FUNC_DEFAULT } = options || {};

    showPortalModalName({
      name: PORTAL_NAME_MODAL_DEFINE.FORM_PROFILE_KYC_SUCCESSFUL_MODAL,
      actionClose,
    });
  };

  const checkPersonalDetailsProfileFullNameChange = (
    currentFullName,
    fullName
  ) => {
    return Boolean(
      stringUtils.replaceAllSpace(currentFullName) &&
        stringUtils.replaceAllSpace(fullName) &&
        currentFullName?.toUpperCase() !== fullName?.toUpperCase()
    );
  };

  const checkPersonalDetailsProfileOccupationChange = (
    currentOccupation,
    occupation
  ) => {
    return Boolean(
      stringUtils.replaceAllSpace(currentOccupation) &&
        stringUtils.replaceAllSpace(occupation) &&
        currentOccupation?.toUpperCase() !== occupation?.toUpperCase()
    );
  };
  const checkPersonalDetailsProfilePrevOccupationChange = (
    currentPrevOccupation,
    prevOccupation
  ) => {
    return Boolean(
      currentPrevOccupation?.toUpperCase() !== prevOccupation?.toUpperCase()
    );
  };

  const checkResidentialAddressProfileFullAddressChange = (
    currentFullAddress,
    fullAddress
  ) => {
    return Boolean(
      stringUtils.replaceAllSpace(currentFullAddress) &&
        stringUtils.replaceAllSpace(fullAddress) &&
        currentFullAddress?.toUpperCase() !== fullAddress?.toUpperCase()
    );
  };

  return {
    handleShowProfileKYCModal,
    handleShowProfileKYCSuccessModal,
    checkPersonalDetailsProfileFullNameChange,
    checkResidentialAddressProfileFullAddressChange,
    checkPersonalDetailsProfileOccupationChange,
    checkPersonalDetailsProfilePrevOccupationChange,
  };
};

export default useProfileKYC;
